// src/modules/checkout/utils/sendReservation.js

import { Actions } from '../../../../client/Actions';

export function sendReservation({
                                  searchParams,
                                  customer,
                                  reservationId,
                                  paymentSelections,
                                  paymentOnBookingPercentage,
                                  securityDepositAmount,
                                  houseId,
                                  onSuccess,
                                  checkinTime,
                                  checkoutTime,
                                  reservationComment,
                                  onError,
                                  setLoader,
                                  consents,
                                  manualDiscounts,
                                  manualAdditionalPayments,
                                }) {
  setLoader?.(true);

  const { startDate, endDate, adults, children, infants } = searchParams;
  const needInvoice = paymentSelections?.needInvoice === true;

  const req = {
    startDate,
    endDate,
    guests: {
      adults,
      children,
      infants,
    },
    reservationId,
    checkinTime,
    checkoutTime,
    reservationComment,
    manualDiscounts,
    manualAdditionalPayments,
    consents,
    payment: {
      securityDepositAmount,
      paymentModel: paymentSelections?.paymentModel,
      needInvoice,
      invoiceName: needInvoice ? paymentSelections?.invoiceName : null,
      invoiceNip: needInvoice ? paymentSelections?.invoiceNip : null,
      invoiceAddress: needInvoice ? paymentSelections?.invoiceAddress : null,
      paymentTypeDeposit: paymentSelections?.paymentTypeDeposit,
      ...(paymentSelections?.paymentModel === 'PARTIAL_PAYMENT' && {
        paymentOnBookingPercentage,
        paymentTypeOnBooking: paymentSelections?.paymentTypeOnBooking,
        paymentTypeOnCheckin: paymentSelections?.paymentTypeOnCheckin,
        paymentDueOnBooking: paymentSelections?.paymentDueOnBooking,
        paymentDueOnCheckin: paymentSelections?.paymentDueOnCheckin
      }),
      ...(paymentSelections?.paymentModel === 'FULL_PAYMENT_ON_BOOKING' && {
        paymentTypeOnBooking: paymentSelections?.paymentTypeOnBooking,
        paymentDueOnBooking: paymentSelections?.paymentDueOnBooking,
      }),
      ...(paymentSelections?.paymentModel === 'FULL_PAYMENT_ON_CHECKIN' && {
        paymentTypeOnCheckin: paymentSelections?.paymentTypeOnCheckin,
        paymentDueOnCheckin: paymentSelections?.paymentDueOnCheckin
      }),
    },
    customer,
  };

  Actions.post(`reserve/${houseId}`, req, (reservation) => {
    setLoader?.(false);
    onSuccess?.(reservation);
  }, (err) => {
    setLoader?.(false);
    onError?.(err);
  });
}
